import { useContext } from 'react';
import * as React from 'react';

export const QueueHistoryContext = React.createContext({});
export const QueueHistoryProvider = QueueHistoryContext.Provider;
export const QueueHistoryConsumer = QueueHistoryContext.Consumer;

QueueHistoryContext.displayName = 'QueueHistoryContext';

export const useQueueHistory = () => useContext(QueueHistoryContext);